import { frontendURL } from '../../../helper/URLHelper';

const DashboardOverview = () => import('./pages/DashboardOverview.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/commercial-dashboard'),
    name: 'commercial_dashboard',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: DashboardOverview,
  },
];
